import { useState, useCallback } from "react";

import { getOutletsValidityInfoWrapper } from "@dineout-cart-client/apis/StealdealItemOutletsValidity";
import { IEligibleCity } from "@dineout-cart-client/interfaces";
import { isEmpty } from "@swiggy-private/js-utils";

interface IUseFetchOutletsValidityInfoReturn {
    eligibleCities: IEligibleCity[];
    isCityApiLoading: boolean;
    hasError: boolean;
    onCheckValidityClick: (itemId: string) => Promise<void>;
}

const useFetchOutletsValidityInfo = (cartId: string | undefined): IUseFetchOutletsValidityInfoReturn => {
    const [eligibleCities, setEligibleCities] = useState<IEligibleCity[]>([]);
    const [isCityApiLoading, setIsCityApiLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    const onCheckValidityClick = useCallback(
        async (itemId: string) => {
            if (isEmpty(cartId)) return;

            setIsCityApiLoading(true);
            setHasError(false);

            setEligibleCities([]);

            try {
                const result = await getOutletsValidityInfoWrapper(itemId, cartId);

                if (result.isOk()) {
                    setEligibleCities(result.unwrap()?.eligibleCities ?? []);
                    return;
                }

                setHasError(true);
            } finally {
                setIsCityApiLoading(false);
            }
        },
        [cartId],
    );

    return { eligibleCities, isCityApiLoading, hasError, onCheckValidityClick };
};

export default useFetchOutletsValidityInfo;
